import globalParams from "@/CommonDP/utils/globalParams";
import designChange from "./form/designChange/index.vue";
import designChange2 from "./form/designChange2/index.vue";
import designChange3 from "./form/designChange3/index.vue";
import common from "./form/common.vue";

/**
 * 用于注册流程的表单
 * @param {} formKey
 * @param {*} formComponent
 * @param {*} isH5 是否是H5的流程
 */
export function registerFlowForm(formKey, formComponent, isH5) {
  if (!isH5) {
    globalParams.set(`flow.form.${formKey}`, formComponent);
  } else {
    globalParams.set(`flow.formH5.${formKey}`, formComponent);
  }
}
/**
 * 注册自定义的表单组件
 */
export function registerStdFlowForm() {
  registerFlowForm("DesignChange", designChange); // 设计变更
  registerFlowForm("DesignChange2", designChange2); // 设计变更
  registerFlowForm("DesignChange3", designChange3); // 设计变更
  registerFlowForm("common", common); // 通用流程
}
